import React from 'react';
import PropTypes from 'prop-types';
import { Line } from 'rc-progress';

// Import Assets
import arrow from '../../../../../img/arrowCurved.png';

// Import styles
import styles from './swapResultCard.module.scss';
import colors from '../../../../../css/_colors.scss';

// Import Formatters
import { shortenHash } from '../../../../../utils/formatters';

const SwapResultCard = ({ style, item, type }) => (
  <div className={styles['swap-result-card-container']}>
    <div className={styles['result-card-banner']}>
      <p className={styles.text}>{type}</p>
    </div>
    <div className={styles['result-card']} style={style}>
      <p className={styles.status}>{item.status}</p>
      <Line
        className={styles['progress-bar']}
        percent="10"
        strokeWidth="2.5"
        trailWidth="2.5"
        strokeColor={colors.lightGreenishBlue}
        trailColor={colors.dirtyBlue}
        strokeLinecap="square"
      />
      <div className={styles.content}>
        <div className={styles['activity-content']}>
          <p className={styles.label}>Acticity ID:</p>
          <p className={styles.value}>{shortenHash(item.hash)}</p>
        </div>

        <div className={styles['address-content']}>
          <img className={styles.arrow} src={arrow} alt="curved-arrow" />
          <div className={styles.content}>
            <p className={styles.label}>From:</p>
            <p className={styles.value}>{shortenHash(item.party.address)}</p>
            <p className={styles.label}>To:</p>
            <p className={styles.value}>{shortenHash(item.counterParty.address)}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

SwapResultCard.propTypes = {
  style: PropTypes.object,
  item: PropTypes.object,
  type: PropTypes.string,
};

export default SwapResultCard;
